import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { userDelete } from '../../../redux/api/userAPI';
import Button from '../../ui/button';

import { useTranslation } from 'react-i18next';

const DeleteUserModal = ({ isOpen, onClose, data }) => {
    const {t} = useTranslation('common');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const closeModal = (refresh = false) => {
        if (loading) return;
        onClose(refresh);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);

        try {
            const usersToDelete = Array.isArray(data) ? data : [data.User_ID || data.user_ID];

            if (usersToDelete.length === 0) {
                setLoading(false);
                closeModal();
                return;
            }

            const isBulkDelete = usersToDelete.length > 1;

            const results = await Promise.all(
                usersToDelete.map(id => userDelete(id, { skipSuccessToast: isBulkDelete }))
            );

            const errors = results
                .filter(result => result.error)
                .map(result => result.error);

            const successCount = usersToDelete.length - errors.length;
            if (isBulkDelete && successCount > 0) {
                toast.success(`${successCount} user(s) successfully deleted.`);
            }

            if (errors.length > 0) {
                setError(errors.join(', '));
                if (errors.length < usersToDelete.length) {
                    onClose(true);
                }
            } else {
                closeModal(true);
            }
        } catch (err) {
            console.error("Error Deleting User(s):", err);
            setError("An unexpected error occurred.");
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) {
        return null;
    }

    const isBulk = Array.isArray(data);
    const count = isBulk ? data.length : 1;
    const userName = !isBulk && data ? `${data.First_name} ${data.Last_name}` : '';

    return (
        <div className="grid space-y-4 w-auto m-2 bg-white p-8 rounded-3xl shadow-lg">
            <p className="text-center text-xl text-[#4C4C66] font-bold">{t('delete_confirmation')}</p>
            <p className="text-center text-md text-[#4C4C66] font-normal">
                {isBulk
                    ? `Are you sure you want to delete ${count} users?`
                    : `${t('are_you_sure_that_you_want_to_delete_this_user')} ${userName}?`
                }
            </p>
            {error && (
                <p className="text-center text-red-500 bg-red-100 p-2 rounded-md">{error}</p>
            )}
            <div className='flex justify-center pt-4 space-x-5'>
                <Button onClick={() => closeModal()} size="large" color="cancel" disabled={loading}>
                    {t('cancel')}
                </Button>
                <Button data-testid="user-delete-submit" onClick={handleSubmit} type="submit" size="large" disabled={loading}>
                    {loading ? t('deleting') : t('delete')}
                </Button>
            </div>
        </div>
    );
};

export default DeleteUserModal;
